export const getNumberFromTimeString = (time) => parseInt(time.replace(':', '').slice(0, time.length - 2), 10)
